import styled, { css } from 'styled-components'

export type TypeProps = 'primary' | 'secondary' | 'search'

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 20px;

  ${({ theme }) => css`
    background-color: ${theme.colors.background};
    border: 1px solid ${theme.colors.textDisabled};
  `}
`

export const InputField = styled.input`
  ${({ theme }) => css`
    color: ${theme.colors.text};
    flex: 1;
    font-size: 16px;
    border: none;
    outline: none;
    background: transparent;
    padding: 8px;
  `}

  &::placeholder {
    color: ${({ theme }) => theme.colors.textDisabled};
  }
`

export const Button = styled.button`
  padding-right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
`
